<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="acknowledgments" id="acknow">
<h1 class="ctfm"><a class="page" id="px"></a><a class="page" id="pxi"></a><a class="xref" href="#/eerlucas0006#racknow">Acknowledgements</a></h1>
<p class="pf">This commentary has taken longer than expected to write. A major factor in this has been the increasing demands of teaching, and especially academic administration, in the United Kingdom Higher Education system over the last few years. I am grateful to my series editor, Professor Gordon McConville, for his patience, occasional encouragement and the implied confidence in me. I am also grateful to my colleagues at Bristol Baptist College for their support and encouragement in all my work. Most of all I want to acknowledge the continual understanding, support and encouragement given by my wife, Hazel, even when the writing of the commentary has taken up time that we might have spent together.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// eer-lucas-0007.vue?5515dfd8